import React from "react";

export const SessionNotificationContext = React.createContext(null);